export default __webpack_public_path__ + "static/media/see.06cc4cf0.png";